import { onScroll, scrollProgress } from '../lib/scroll';

// Reading progress bar — writes a percentage into --progress; CSS draws it.
export function initScrollProgress(): void {
  const bar = document.querySelector<HTMLElement>('[data-scroll-progress]');
  if (!bar) return;

  onScroll(() => {
    bar.style.setProperty('--progress', `${(scrollProgress() * 100).toFixed(2)}%`);
  });
}
